import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./add.css"

interface button {
  onClick: any;
  disabled?: boolean
}

const AddButton = ({ onClick, disabled }: button) => {
  const { t } = useTranslation("common");
  return (
    <>
      <Button
        disabled={disabled}
        icon={<PlusOutlined style={{ fontSize: "16px" }} />}
        className="addbutton"
        onClick={onClick}
      >
        {t("add")}
      </Button>
    </>
  );
};

export default AddButton;
